module.exports = __webpack_public_path__ + "static/img/knowleage-file-bg3.622afa4c.png";